module.exports = __webpack_public_path__ + "media/PAG87-01.3d0748d7.mp3";